import { Close, OndemandVideoRounded } from '@mui/icons-material';
import { fancyTimeFormat } from './timeHelper';
import { episodePlaybackLabel } from '../utils/episodePlaybackLabel';

export default function VideoAudioContinuation({ duration, seconds, expanded, playbackRate = 1, onContinue, onDismiss }) {
    const remaining = Math.max(0, duration - seconds);
    const title = expanded ? `About ${fancyTimeFormat(remaining / Math.max(playbackRate, 0.1))} left`
        : `About ${episodePlaybackLabel(duration, seconds, true).title}`;
    return <div className='trackVideoContinuation episodePlaybackGlass'>
        <div className='trackVideoContinuationActions'>
            <button type='button' className='trackVideoContinueButton' aria-label={`Continue audio from video, ${title.toLowerCase()}`} onClick={onContinue}>
                <OndemandVideoRounded aria-hidden='true' />
                <span><strong>Continue from video</strong><span>{title}</span></span>
            </button>
            <button type='button' className='trackVideoDismissButton' aria-label='Dismiss video continuation' onClick={onDismiss}><Close aria-hidden='true' /></button>
        </div>
    </div>;
}
